import type React from 'react';

const RETRY_LAZY_KEY = 'retry-lazy-refreshed';

// a function to retry loading a chunk to avoid chunk load error for out of date code
export const lazyRetry = function <T extends React.ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>
): Promise<{ default: T }> {
  return new Promise((resolve, reject) => {
    // check if the window has already been refreshed
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem(RETRY_LAZY_KEY) || 'false');
    // try to import the component
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem(RETRY_LAZY_KEY, 'false'); // success so reset the refresh
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem(RETRY_LAZY_KEY, 'true'); // we are now going to refresh
          return window.location.reload(); // refresh the page
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });
};
